import { Code, Server, Cloud, Layout } from "lucide-react";

export default function OfferData() {
  return null;
}

export const data = [
  {
    icons: Server,
    text: "Backend Developments",
    description:
      "Robust backend solutions using Node.js, Express, MongoDB, and secure APIs.",
  },
  {
    icons: Cloud,
    text: "Cloud Deployment",
    description:
      "Deploying scalable, secure cloud applications using AWS, Firebase, and modern DevOps practices",
  },
  {
    icons: Code,
    text: "UI/Ux design",
    description:
      "Intuitive, modern, user-centric design that enhances user experience and engagement.",
  },
  {
    icons: Layout,
    text: "Frontend Development",
    description:
      "Building fast, accessible web apps with React, Tailwind CSS, TypeScript, and modern frontend tools.",
  },
];
